module.exports = __webpack_public_path__ + "img/easybill.4589da96.svg";